import { z } from 'zod'

export const streetTypeSuggestionsSchema = z.array(
  z.object({
    value: z.string(),
  })
)

export type StreetTypeSuggestions = z.infer<typeof streetTypeSuggestionsSchema>

export const suburbStateSuggestionsSchema = z.array(
  z.object({
    value: z.string(),
  })
)

export type SuburbStateSuggestions = z.infer<typeof suburbStateSuggestionsSchema>
